import type { ReformatBlockedReason } from '~/domain/services/imageService';

/**
 * Message per refusal reason. Written out rather than built from the reason
 * string so every key stays greppable — nothing checks that a message id
 * exists, and a missing one falls back to English silently.
 *
 * Shared by the control that opens the reformat and the one that starts it,
 * so a reason is worded the same wherever the user meets it.
 */
export const REFORMAT_BLOCKED_MESSAGE_IDS: Record<
    ReformatBlockedReason,
    string
> = {
    widePixelRange: 'reformatBlockedWidePixelRange',
    imageStillLoading: 'reformatBlockedImageStillLoading',
    imageIncomplete: 'reformatBlockedImageIncomplete',
    mixedGeometry: 'reformatBlockedMixedGeometry',
    regionOutsideSource: 'reformatBlockedRegionOutsideSource',
    tooFewSlices: 'reformatBlockedTooFewSlices',
    outputTooLarge: 'reformatBlockedOutputTooLarge',
    seriesNumberTaken: 'seriesNumberTaken',
    seriesNumberOutOfRange: 'seriesNumberOutOfRange',
    seriesDescriptionInvalid: 'seriesDescriptionInvalidChars',
    extensionNeedsMultipleSlices: 'reformatBlockedExtensionNeedsMultipleSlices',
};
